<template>
    <div class="leftBottom">
        <div class="ad">
            <div class="filterBox"></div>
            <p class="title">网格数据统计</p>
            <div id="pie" style="width: 100%; height: 320px"></div>
        </div>
    </div>
</template>

<script>
import echarts from 'echarts';
export default {
    props: {
        jgData: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            myChart: ''
        };
    },
    computed: {},
    created() {},
    mounted() {
        this.myChart = echarts.init(document.getElementById('pie'), null, {
            devicePixelRatio: 2
        });
    },
    watch: {
        jgData(nVal) {
            console.log(nVal);
            this.setOption();
        }
    },
    methods: {
        setOption() {
            var option = {
                series: [
                    {
                        type: 'pie',
                        center: ['50%', '40%'], // 圆心
                        radius: ['40%', '50%'], // 圆环图
                        color: ['#EE3F86', '#29AAE1', '#FAAF3B', '#22B473', '#3771ff', '#00d1ff', '#2ff0d2'],
                        itemStyle: {
                            borderRadius: 10,
                            // borderColor: '#fff',
                            borderWidth: 2
                        },
                        data: this.jgData,
                        labelLine: {},
                        label: {
                            show: true
                        },
                        emphasis: {
                            show: true
                        }
                    }
                ]
            };

            this.myChart.setOption(option, true);
        }
    },
    components: {}
};
</script>
<style scoped lang="scss">
.leftBottom {
    position: absolute;
    left: 70px;
    bottom: 65px;
    .filterBox {
        background: rgba($color: #000000, $alpha: 0.4);
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        z-index: -1;
        -webkit-filter: blur(9px);
        -moz-filter: blur(9px);
        -o-filter: blur(9px);
        -ms-filter: blur(9px);
        filter: blur(30px);
    }
    .ad {
        position: relative;
        background: url(../../assets/img/card.png) no-repeat;
        background-position: 0 0;
        background-size: 100% 100%;
        width: 470px;
        height: 370px;
        margin-top: 10px;
        box-sizing: border-box;
        padding: 18px;
    }
}
.title {
    background: rgba($color: #00c2ff, $alpha: 0.6);
    color: #ffffff;
    font-weight: bold;
    font-size: 20px;
    padding: 10px;
    display: inline-block;
}
</style>
